import React from 'react';
import styles from '../assets/guardianDashboard.module.css';

const GuardianStageHeader = ({ active, sent, paymentConfirmed }) => {
  const stageOneLabel = sent ? 'Documents Sent' : 'Documents Required';
  return (
    <div className={styles.progressIndicator}>
      <div
        className={`${styles.progressStage} ${
          active === 1 ? styles.active : styles.completed
        }`}
      >
        <strong>Stage 1:</strong> {stageOneLabel}
      </div>
      <div
        className={`${styles.progressStage} ${
          active === 2 ? styles.active : styles.pending
        }`}
      >
        <strong>Stage 2:</strong> Find your Property
      </div>
      <div
        className={`${styles.progressStage} ${
          active === 3 ? styles.active : styles.pending
        }`}
      >
        <strong>Stage 3:</strong>{' '}
        {paymentConfirmed ? 'Awaiting Key Collection' : 'Payment Pending'}
      </div>
    </div>
  );
};

export default GuardianStageHeader;
